<div class="segment-control" [ngClass]="getSegmentClasses()">
  <ul class="">
    <li *ngFor="let segment of segments; let i = index">
      <a
        (click)="selectSegment(segment)" [ngClass]="getClasses(segment)"
      >
        {{ segment.text }}
      </a>
    </li>
  </ul>
</div>
